'use client';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';

import { ProductTabContainer } from './product-tab-container';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ProductTabParameters({
  product,
  title,
}: {
  product: ProductDetailData;
  title: string;
}) {
  return (
    <ProductTabContainer title={title}>
      <div className="flex w-full flex-col items-start justify-start gap-6">
        <div className="flex w-full flex-col items-start justify-start gap-1">
          {product.attributes?.map(attribute => (
            <div
              key={attribute.name}
              className={cn('flex w-full items-start justify-start gap-4 bg-[#FAFAFA] p-2')}
            >
              <span className="min-w-32 max-w-32 text-left text-sm font-normal text-foreground sm:min-w-52 lg:min-w-[200px] xl:min-w-[300px]">
                {attribute.name}
              </span>
              <p className={cn('text-left text-sm font-semibold')}>
                {attribute.values?.map((value, index) => (
                  <>
                    {value.name}
                    {index < (attribute.values?.length ?? 0) - 1 ? ', ' : ''}
                  </>
                ))}
              </p>
            </div>
          ))}
        </div>
      </div>
    </ProductTabContainer>
  );
}
